/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { QuestionChangesControllerFindOneQueryResponse, QuestionChangesControllerFindOnePathParams, QuestionChangesControllerFindOneQueryParams, QuestionChangesControllerFindOne400, QuestionChangesControllerFindOne401, QuestionChangesControllerFindOne403, QuestionChangesControllerFindOne404 } from "../../models/checklistsController/QuestionChangesControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { questionChangesControllerFindOne } from "../../clients/checklistsService/questionChangesControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const questionChangesControllerFindOneQueryKey = (id: QuestionChangesControllerFindOnePathParams["id"], params: QuestionChangesControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/checklist-question-changes/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type QuestionChangesControllerFindOneQueryKey = ReturnType<typeof questionChangesControllerFindOneQueryKey>;
export function questionChangesControllerFindOneQueryOptions(id: QuestionChangesControllerFindOnePathParams["id"], params?: QuestionChangesControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = questionChangesControllerFindOneQueryKey(id, params);
  return queryOptions<QuestionChangesControllerFindOneQueryResponse, ResponseErrorConfig<QuestionChangesControllerFindOne400 | QuestionChangesControllerFindOne401 | QuestionChangesControllerFindOne403 | QuestionChangesControllerFindOne404>, QuestionChangesControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return questionChangesControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a specific question change flag by ID
 * {@link /api/v1/checklist-question-changes/:id}
 */
export function useQuestionChangesControllerFindOne<TData = QuestionChangesControllerFindOneQueryResponse, TQueryData = QuestionChangesControllerFindOneQueryResponse, TQueryKey extends QueryKey = QuestionChangesControllerFindOneQueryKey>(id: QuestionChangesControllerFindOnePathParams["id"], params?: QuestionChangesControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<QuestionChangesControllerFindOneQueryResponse, ResponseErrorConfig<QuestionChangesControllerFindOne400 | QuestionChangesControllerFindOne401 | QuestionChangesControllerFindOne403 | QuestionChangesControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? questionChangesControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...questionChangesControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<QuestionChangesControllerFindOne400 | QuestionChangesControllerFindOne401 | QuestionChangesControllerFindOne403 | QuestionChangesControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}